import { FrownOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router";
import { Button, Result } from "antd";

export default function EmailConfirmationError() {
  const navigate = useNavigate();
  const goToLogin = () => {
    navigate("/login");
  };
  return (
    <div className="flex flex-col w-full justify-center items-center h-screen">
      <Result
        icon={<FrownOutlined style={{ color: "#0C98D0", fontSize: "100px" }} />}
        title="Email Confirmation Error"
        subTitle={
          <div className="flex flex-col">
            <p>
              The email confirmation link is invalid or has already been used.
            </p>
            <p>Please try to login or contact support for assistance</p>
          </div>
        }
        extra={
          <Button
            className="w-36 mt-2 rounded-sm shadow-none"
            type="primary"
            onClick={goToLogin}
          >
            Login
          </Button>
        }
      />
    </div>
  );
}
